import axios from "axios";

const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });
const limpar = (p) => Object.fromEntries(Object.entries(p).filter(([, v]) => v !== undefined && v !== null && v !== ""));

export async function carregarMetaAds(params) {
  const { data } = await axios.get("/api/reports/offers/meta-ads", { ...auth(), params: limpar(params) });
  return data;
}

export async function carregarCampanhaMeta(chave, params) {
  const { data } = await axios.get(`/api/reports/offers/meta-ads/${encodeURIComponent(chave)}`, { ...auth(), params: limpar(params) });
  return data;
}

// ROI = faturado ÷ investido, em "x" (decisão do dono em 04/10/2026). Abaixo de 10, duas casas.
export const retornoX = (r) => (r == null ? "—" : `${Number(r).toLocaleString("pt-BR", { maximumFractionDigits: Number(r) < 10 ? 2 : 1 })}x`);

// A conta sobre o LUCRO não se chama ROI, para a palavra não ter dois sentidos.
const brl = (v) => Number(v).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
export const lucroPorReal = (v) =>
  (v == null ? null : v >= 0 ? `${brl(v)} de lucro por R$ 1 investido` : `${brl(-v)} de prejuízo por R$ 1 investido`);

export const STATUS_CAMPANHA = {
  ACTIVE: ["No ar", "text-emerald-600 dark:text-emerald-400"],
  ENCERRADA: ["Encerrada", "text-muted-foreground"],
  PAUSED: ["Pausada", "text-muted-foreground"], CAMPAIGN_PAUSED: ["Pausada", "text-muted-foreground"], ADSET_PAUSED: ["Pausada", "text-muted-foreground"],
  PENDING_REVIEW: ["Em análise", "text-amber-600"], IN_PROCESS: ["Em análise", "text-amber-600"],
  DISAPPROVED: ["Reprovada", "text-red-500"], WITH_ISSUES: ["Precisa de atenção", "text-red-500"], PENDING_BILLING_INFO: ["Falta pagamento", "text-red-500"],
  ARCHIVED: ["Arquivada", "text-muted-foreground"], DELETED: ["Apagada", "text-muted-foreground"],
  desconhecida: ["Não lida ainda", "text-muted-foreground"], sem_parametros: ["Sem os parâmetros", "text-amber-600"],
};
